import { Suspense, useEffect, useRef, type ReactNode } from 'react';
import { observeNewsletterSections } from '@/lib/subscribeFunnelAnalytics';
import Footer from '@/components/Footer/Footer';
import ArticleCards from './sections/ArticleCards';
import FAQ from './sections/FAQ';
import Hero from './sections/Hero';
import PromoVideo from './sections/PromoVideo';
import WhyAtrivial from './sections/WhyAtrivial';
import {
  FinalCTA,
  HowAtrivialWorks,
  PortalPreview,
  SubscribePricingSection,
} from './homepageSections';
// The prerendered product clip keeps its geometry before its section hydrates.
import './components/newsletter-demo-clip.css';
import './for-newsletters.css';

export default function ForNewslettersPage({ headline }: { headline?: ReactNode }) {
  const pageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!pageRef.current) return;
    return observeNewsletterSections(pageRef.current);
  }, []);

  return (
    <div
      ref={pageRef}
      className="nl-marketing-page for-newsletters-page min-h-screen bg-nl-paper font-nl-sans text-nl-ink antialiased"
    >
      <Hero headline={headline} />
      <WhyAtrivial />
      <Suspense fallback={null}>
        <HowAtrivialWorks />
      </Suspense>
      <Suspense fallback={null}>
        <SubscribePricingSection eyebrow="Pricing" enterpriseHref="#demo" surface="paper" />
      </Suspense>
      <Suspense fallback={null}>
        <PortalPreview />
      </Suspense>
      <PromoVideo />
      <ArticleCards />
      <FAQ />
      <Suspense fallback={null}>
        <FinalCTA />
      </Suspense>
      <Footer />
    </div>
  );
}
